export default __webpack_public_path__ + "static/media/Contact2.62e05759.gif";